export const onValidationError = (e, mc, formikRef, questionnaire, groupQuestionnaires) => {
    console.log("onValidationError -> error", e)
    mc.error('Please complete all required fields to proceed.')
    const allQuestions = questionnaire;
    groupQuestionnaires.map(questionnaire => questionnaire.map(question => allQuestions.push(question)));
  
    let firstErrorKey = null;
    try {
      for (const question of allQuestions) {
        if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
        formikRef.current.setFieldError(question.key, null);
      }
  
      if (e.inner) e.inner.map(({ message, path }) => {
        const question = allQuestions.find(question => question.key === path);
        if (question) mc.error(`The Field ${question.dsQuestion} is Required`);
        if (e.message === "Email inválido") formikRef.current.setFieldError(question.key, `* Email inválido`);
        else formikRef.current.setFieldError(question.key, `* Required Field`);
        if (!firstErrorKey) firstErrorKey = question.key;
      })
  
      if (firstErrorKey) {
        const elements = global.window.document.getElementsByName(firstErrorKey);
        if (elements?.length) {
          setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
        }
      }
    } catch (e) {
      console.log('onValidationError catch', e)
    }
  }


  export const getQuestionIsDisabled = (isBound) => {
    if (isBound) return true;
    return false;
  }

  export const removeAnswersDuplicateSession = (questions) => {
    questions = JSON.parse(JSON.stringify(questions));
    return questions.map(question => {
      const { defaultValue } = question.behaviorObject || {};
      question.answer = defaultValue || "";
      question.answerJson = defaultValue || "";
      question.idAnswerOption = null;
      question.idPerson = null;
      question.idQuestionnaireAnswers = null;
      question.idQuestionnaireAnswersParent = null;
      question.idQuestionnaireAnswersRoot = null;
      question.key = null;
      return question;
    })
  }